import apiClient from './client';
import { LoginRequest, LoginResponse, RefreshResponse, Admin } from '../types';

export const authApi = {
  // Login
  login: async (credentials: LoginRequest): Promise<LoginResponse> => {
    const response = await apiClient.post<LoginResponse>('/admin/auth/login', credentials);
    return response.data;
  },

  // Logout
  logout: async (): Promise<void> => {
    await apiClient.post('/admin/auth/logout');
  },

  // Refresh token
  refresh: async (refreshToken: string): Promise<RefreshResponse> => {
    const response = await apiClient.post<RefreshResponse>('/admin/auth/refresh', {
      refreshToken,
    });
    return response.data;
  },

  // Get current admin profile
  getProfile: async (): Promise<Admin> => {
    const response = await apiClient.get<Admin>('/admin/auth/me');
    return response.data;
  },

  // Change password
  changePassword: async (currentPassword: string, newPassword: string): Promise<void> => {
    await apiClient.post('/admin/auth/change-password', {
      currentPassword,
      newPassword,
    });
  },
};

export default authApi;
